import React from 'react';
import { useTheme } from '../hooks/useTheme';

const ThemeSelector: React.FC = () => {
  const { theme, changeTheme } = useTheme();

  const isDark = theme === 'alpine-dark' || theme === 'quartz-dark';
  const nextTheme = isDark ? 'alpine' : 'alpine-dark';
  const icon = isDark ? 'fa-moon' : 'fa-sun';
  const title = isDark ? 'Switch to light' : 'Switch to dark';

  const handleClick = () => {
    changeTheme(nextTheme);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="p-2 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors flex items-center"
      aria-label={title}
      title={title}
    >
      <i className={`fa-solid ${icon} text-sm`} />
    </button>
  );
};

export default ThemeSelector;
